import { Labels } from '~/config/translations'

export const useTranslations = () => {

  const localization = useBaseLocalization()
  const currentLanguage = localization.getCurrentLanguage()
  const isMultiLanguage = localization.isMultiLanguage()

  const translate = (value: string): string => {
    if (!isMultiLanguage) {
      return value
    }

    const translation = localization.translate(value)

    if (translation !== value) {
      return translation
    }

    return Labels[currentLanguage.name]?.[value] || Labels.en[value] || value
  }

  return {
    translate,
  }
}
